export default __webpack_public_path__ + "static/media/md-card-bg-genai.e7f29063.png";